module.exports = __webpack_public_path__ + "static/img/img-p3-6gs.2eb93166.jpg";